import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { Instagram, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#F3EFE6] text-[#1A1A18] py-16" data-testid="main-footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div>
            <img src="https://customer-assets.emergentagent.com/job_regal-collection-2/artifacts/87220c1a_Screenshot_2026-04-07_at_00.16.22-removebg-preview%20%281%29.png" alt="Studio Crochet" className="h-16 w-auto object-contain mb-4" />
            <p className="text-sm text-[#4A463F] font-outfit">{t('premiumDesc')}</p>
          </div>

          <div>
            <h3 className="text-[#C29B57] font-cormorant text-xl mb-4">{t('quickLinks')}</h3>
            <ul className="space-y-2">
              <Link to="/shop" className="block text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">{t('shop')}</Link>
              <Link to="/sale" className="block text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">{t('sale')}</Link>
              <Link to="/bestseller" className="block text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">{t('bestSeller')}</Link>
              <Link to="/about" className="block text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">{t('about')}</Link>
              <Link to="/contact" className="block text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">{t('contact')}</Link>
            </ul>
          </div>

          <div>
            <h3 className="text-[#C29B57] font-cormorant text-xl mb-4">{t('categories')}</h3>
            <ul className="space-y-2">
              <Link to="/shop?category=saree" className="block text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">Saree</Link>
              <Link to="/shop?category=lehenga" className="block text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">Lehenga</Link>
              <Link to="/shop?category=pakistani-suit" className="block text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">Pakistani Suit</Link>
              <Link to="/shop?category=indo-western" className="block text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">Indo-Western</Link>
              <Link to="/shop?category=family-outfit" className="block text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">Family Outfit</Link>
            </ul>
          </div>

          <div>
            <h3 className="text-[#C29B57] font-cormorant text-xl mb-4">{t('contactUs')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-[#4A463F]">
                <span className="text-[#C29B57] mt-1">📍</span>
                <span>04, 1st floor, bliss height, sector 104, hazipur, noida-201304</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-[#C29B57]" />
                <a href="tel:9999633121" className="text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">9999633121</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-[#C29B57]" />
                <a href="mailto:ekta.verma320@gmail.com" className="text-sm text-[#4A463F] hover:text-[#C29B57] transition-colors">ekta.verma320@gmail.com</a>
              </li>
              <li className="flex items-center gap-2 mt-4">
                <a href="https://www.instagram.com/studio.crochet.ektasingh" target="_blank" rel="noopener noreferrer" className="text-[#C29B57] hover:text-[#99733D] transition-colors">
                  <Instagram className="w-5 h-5" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[#EBE4D5] text-center">
          <p className="text-sm text-[#4A463F] font-outfit">{t('allRights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
